'use client'

import MarkerPin2Icon from '@/app/[locale]/_assets/icon-components/MarkerPin2'
import { IBranch } from '@/app/[locale]/_types'
import { Box, HStack, Stack, Text, VStack } from '@chakra-ui/react'
import React, { Dispatch } from 'react'

interface IProps {
  data: IBranch[]
  branchRefs?: any
  selectedBranch: IBranch | null
  setSelectedBranch: Dispatch<IBranch | null>
  onSelectBranch?: (val: IBranch | null) => void
}

const Content = ({
  data,
  branchRefs,
  onSelectBranch,
  selectedBranch,
  setSelectedBranch,
}: IProps) => {
  return (
    <Stack
      flex={1}
      mt={2}
      gap={3}
      w={'full'}
      maxH={{ base: 'calc(100dvh - 326px)', lg: '290px' }}
      overflow={'auto'}
      scrollbar={'hidden'}
    >
      {data?.map((el) => {
        return (
          <VStack
            me={{ base: 0, lg: 2 }}
            key={el.id}
            ref={(elRef) => {
              if (elRef) {
                if (branchRefs?.current) {
                  branchRefs.current[el.id] = elRef
                }
              }
            }}
            alignItems={'start'}
            border={'1px solid'}
            borderColor={selectedBranch?.id === el.id ? 'primary' : '#ffffff2e'}
            rounded={16}
            cursor={'pointer'}
            _hover={{
              border: '1px solid',
              borderColor: 'primary',
            }}
            color='text'
            gap={2}
            p={4}
            onClick={() => {
              setSelectedBranch(el)
              onSelectBranch?.(el)
            }}
          >
            <HStack justifyContent={'space-between'} w={'full'}>
              <HStack color={'text'} alignItems={'center'} gap={2}>
                <Box minW='24px'>
                  <MarkerPin2Icon />
                </Box>
                <Text fontWeight={500} fontSize={18}>
                  {el?.name}
                </Text>
              </HStack>
              <Box color={'primary'} fontSize={'xs'}>
                <Text minW={115} textAlign={'end'}>
                  с {el?.open_time} до {el?.close_time}
                </Text>
              </Box>
            </HStack>
            <Text fontSize={'xs'} color='text.muted'>
              {el.address}
            </Text>
          </VStack>
        )
      })}
    </Stack>
  )
}

export default Content
